import { FC, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader } from "../../../components/loader/SpinnerLogo";
import useFetch from "../../../hooks/useFetch";
import useHandleErrors from "../../../hooks/useHandleErrors";
import { UserService } from "../../../services/user/userService";
import { User } from "../../../type/entities/user-type";
import UserForm from "../UserForm";
import UserEditLayout from "./UserEditLayout";

const UserEdit: FC = () => {

    // HOOKS
    
    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new UserService();

    // FUNCTIONS

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER LOS DATOS DEL USUARIO
     * @EN GET USER DATA
     */
    //--------------------------------------------------------------------------------------------------------------
    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getUserById(id as string);
        return response.getResponseData() as User;
    }, [id]));
    //--------------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES MANEJAR EL ENVIO DEL FORMULARIO DE EDICION
     * @EN HANDLE THE SUBMIT OF THE EDIT FORM
     */
    //--------------------------------------------------------------------------------------------------------------
    const handleSubmit = async (values: any) => {
        try {
            if (values.password !== "" && values.passwordConfirm !== "") {
                const result = await service.changePassword(id, values.password, values.passwordConfirm);

                if (result.getResponseData().success) {
                    toast.success("Contraseña cambiada correctamente");
                } else {
                    toast.error("Error al cambiar la contraseña");
                }
            }

            const response = (await service.editUser(values)).getResponseData();

            if (response.success) {
                navigate(-1);
                toast.success("Usuario editado correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al editar el usuario");
        }
    };
    //--------------------------------------------------------------------------------------------------------------

    if (loading) return <Loader />;

    // RENDER

    return (
        <UserEditLayout>
            {(data !== null && data !== undefined) && <UserForm data={data} submit={handleSubmit} isLoading={loading} profileImg={data.profileImg} />}
        </UserEditLayout>
    );
};

export default UserEdit;